module.exports = __webpack_public_path__ + "img/withdraw.e5b2152a.svg";